import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'

// 引入全局样式
import './assets/styles/index.styl'
// import '../theme/index.css'
import 'element-ui/lib/theme-chalk/index.css'

// 引入全局组件
import './components/index.js'
import './permission.js'
import * as filters from './filters'

import CONFIG from './config'
import krp from './plugins/krpano'
import bus from './plugins/bus'

import Toast from 'vant'
import 'vant/lib/toast/style'

import { Input, Button, Loading, Slider, Dialog, Tooltip } from 'element-ui'

Vue.use(Input)
  .use(Button)
  .use(Loading)
  .use(Slider)
  .use(Dialog)
  .use(Tooltip)

Vue.use(Toast)

Vue.use(krp)
Vue.use(bus)
Vue.prototype.$CONFIG = CONFIG
Vue.prototype.$tolst = Toast
Vue.prototype.$loading = Loading

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.config.productionTip = false

const VM = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

window.$VM = VM
